import { Seo } from "../components/Seo";
import { HomeHero } from "../components/home/HomeHero";
import { PathsSection, ServicesBento, AltitudeSection } from "../components/home/HomeSections";
import { ProcessSection, ProofPreview, AnswerPreview } from "../components/home/HomeMore";
import { SafetyStrip, SampleReviews, CtaBand } from "../components/Sections";
import { Marquee } from "../components/Motion";

const MARQUEE = [
  "Diagnose before replacing",
  "5,280 ft changes combustion",
  "Gas smell? Leave first, call from outside",
  "Repair or replace is a math question",
  "Airflow explains most cold rooms",
  "Load-sized, not nameplate-sized",
];

export default function Home() {
  return (
    <>
      <Seo
        title="Denver Furnace Repair | Diagnosis-First Furnace Service (Demonstration)"
        description="A VisibilityReady demonstration of a Denver furnace contractor site: no-heat repair, repair-or-replace guidance, tune-ups, heat pumps, and gas safety for Denver metro homes."
        path="/"
        md="/index.md"
        image="denver-home-1280.webp"
      />
      <HomeHero />
      <SafetyStrip />
      <div className="bg-bone"><Marquee items={MARQUEE} /></div>
      <PathsSection />
      <ServicesBento />
      <AltitudeSection />
      <ProcessSection />
      <ProofPreview />
      <SampleReviews />
      <AnswerPreview />
      <CtaBand />
    </>
  );
}
